import { Box, Typography } from '@mui/material';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';

/**
 * One-line key for the planned-utilisation lists (Dashboard widget + Reports
 * table). Explains the leave indicator so a high % isn't misread: utilisation
 * is shown against **available** capacity, and the beach icon flags approved
 * leave in the period (a full-period absence reads "On leave" rather than 0%).
 */
export function LeaveKey() {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.625, mt: 1 }}>
      <BeachAccessIcon sx={(theme) => ({ fontSize: 12, color: theme.palette.statusInk.info, flexShrink: 0 })} />
      <Typography sx={{ fontSize: '0.6875rem', color: 'text.disabled' }}>
        On leave / approved leave this period — utilisation is shown against available capacity
      </Typography>
    </Box>
  );
}
